<template>
	<ListDetailLayout
			:store="firmwareTypesStore"
      index-route-name="admin.firmware.types"
			create-permissions="create:firmware-types"
			@on-create="$router.push({ name: 'admin.firmware.types.type', params: { firmwareType: 'NEW' } })"
			@on-paginate="(page) => useOnPaginate(page, refreshFirmwareTypes, params)"
			@on-search="(page) => useOnSearch(page, refreshFirmwareTypes, params)"
			create-button-admin-page="create-firmware-type-btn"
	        search-admin-page="search-firmware-type-admin-page"
	>

		<template #list>
			<li v-for="firmwareType in firmwareTypesStore.getFirmwareTypes" :key="firmwareType.id">
				<router-link :to="{ name: 'admin.firmware.types.type', params: { firmwareType: firmwareType.id } }" v-slot="{isActive}">
					<div :class="[isActive ? 'border-primary-500 dark:bg-surface-600' : 'border-transparent hover:bg-surface-50 dark:hover:bg-surface-800', 'transition-colors border-l-4 flex items-center justify-between gap-x-6 py-5 pl-3 pr-4 bg-surface-0 dark:bg-surface-800']">

						<div class="min-w-0">
							<div class="flex items-start gap-x-3">
								<p class="text-sm font-semibold leading-6 text-surface-900 dark:text-surface-200">{{ firmwareType.name }}</p>
							</div>
							<div class="mt-1 flex items-center gap-x-2 text-xs leading-5 text-surface-500 dark:text-surface-400">
								<p class="whitespace-nowrap">
									{{ firmwareType.key }}
								</p>
							</div>
						</div>

					</div>
				</router-link>
			</li>
		</template>

		<template #detail>
				<router-view v-if="$route.params.firmwareType" @on-save="refreshFirmwareTypes" @on-delete="refreshFirmwareTypes"></router-view>
		</template>

	</ListDetailLayout>
</template>

<script>
import ListDetailLayout from "@/Layouts/ListDetailLayout.vue";
import Container from "@/Components/Container.vue";
import { mapStores } from "pinia";
import { useFirmwareTypesStore } from "@/stores/firmwareTypes.js";
import { useOnPaginate, useOnSearch } from "@/Composables/Pagination.js";

export default {
	name: "FirmwareTypesIndex",
	data() {
		return {
			params: {}
		}
	},
	methods: {
		useOnSearch,
		useOnPaginate,
		refreshFirmwareTypes(){
			return this.firmwareTypesStore.indexFirmwareTypes(this.params)
		}
	},
	components: {Container, ListDetailLayout},
	computed: {
		...mapStores(useFirmwareTypesStore)
	},

	async mounted() {
		await this.refreshFirmwareTypes()
	}
}
</script>